/**
=========================================================
* MD UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/MD-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the MDware.
*/
import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import { useAppServices } from 'hook/services'
import { useEffect, useState } from 'react'
import EditModal from '../../EditModal'

export default function DataTableData() {
  const AppService = useAppServices()
  const [List, setList] = useState([])
  const [loader, setloader] = useState(true)
  const [apps, setApps] = useState([])

  const getTierApps = async () => {
    const { response, error } = await AppService.app_tiers.get()
    if (response) {
      // setList(response.data)
      setloader(false)
    } else {
      setList([])
      setloader(false)
    }
  }

  const formatApps = (apps) => {
    if (!apps || apps.length === 0) return 'No Apps'
    return apps.map((item) => item?.label).join(' - ')
  }

  const onLoad = () => {
    getTierApps()
  }
  const handleDelete = async (id) => {
    const { response } = await AppService.app_listing.delete({
      query: `_id=${id}`,
    })
    if (response) onLoad()
  }

  useEffect(onLoad, [])
  return {
    loader: loader,
    apps: apps,
    handleRefresh: onLoad,
    dataTableData: {
      columns: [
        { Header: 'Name', accessor: 'name' },
        { Header: 'Plan ID', accessor: 'plan_id' },
        { Header: 'Apps', accessor: 'apps' },
        { Header: 'Action', accessor: 'action' },
      ],

      rows: List.map((data) => ({
        name: data.name,
        plan_id: data.plan_id,
        apps: formatApps(data?.apps),
        action: (
          <MDBox>
            <EditModal data={data} apps={apps} handleRefresh={onLoad} />
            <MDButton
              variant="contained"
              color="error"
              size="small"
              sx={{ marginLeft: 2 }}
              onClick={() => handleDelete(data._id)}
            >
              Delete
            </MDButton>
          </MDBox>
        ),
      })),
    },
  }
}
